/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { PREMEETING_BUTTONS_ELECTRON, } from "../../base/config/constants";
import Toolbox from "../../toolbox/components/web/Toolbox";
const useStyles = makeStyles()(theme => {
    return {
        container: {
            gridArea: 'settings',
            ' .toolbox-content': {
                marginBottom: 0,
            },
            ' .toolbox-content-items': {
                paddingLeft: 0,
                paddingRight: 0,
                background: "transparent",
            },
            ' .toolbox-content-items>div': {
                marginRight: '12px',
            },
            ' .toolbox-button .jitsi-icon > svg': {
                width: '24px',
                height: '24px',
            },
            ' .hangup-button .jitsi-icon > svg': {
                width: '32px',
                height: '32px',
            }
        }
    };
});
const PrejoinSettings = ({ buttons }) => {
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.container },
        React.createElement(Toolbox, { toolbarButtons: buttons, isLobby: true })));
};
function mapStateToProps() {
    return {
        buttons: PREMEETING_BUTTONS_ELECTRON,
    };
}
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(PrejoinSettings);
